module.exports = __webpack_public_path__ + "static/media/bnb-qr.e12a3891.png";